var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRight2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 91.349,
    height: 59.893,
    viewBox: "0 0 91.349 59.893",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "buy-cart-discount-2-svgrepo-com",
    transform: "translate(-11.9 -96.015)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2514",
    "data-name": "Path 2514",
    d: "M150.12,129.524a1.32,1.32,0,0,0-1.778-.524l-7.054,3.892h0l-2.769,1.534L109.1,150.593a4.044,4.044,0,0,1-5.838-4.678,3.927,3.927,0,0,1,1.946-2.414h0l36.113-19.853h0l3.144-1.721a1.31,1.31,0,1,0-1.254-2.3l-1.59.879-4.6-21.5a3.691,3.691,0,0,0-5.408-2.526L86.108,121.46l-6.343-6.512a1.306,1.306,0,0,0-1.572-.243l-7.747,4.266a1.31,1.31,0,0,0,1.254,2.3l6.886-3.78L84.911,124h0l17.664,18.169a6.7,6.7,0,0,0-1.272,8.083,6.681,6.681,0,0,0,5.857,3.462,6.575,6.575,0,0,0,3.2-.823l2.171-1.2a6.62,6.62,0,0,0,.43.992,6.216,6.216,0,0,0,5.464,3.218,6.307,6.307,0,0,0,2.994-.767,6.233,6.233,0,0,0,2.451-8.458,5.771,5.771,0,0,0-.6-.9l10.123-5.557a6.62,6.62,0,0,0,.43.992,6.216,6.216,0,0,0,5.464,3.218,6.306,6.306,0,0,0,2.994-.767,6.233,6.233,0,0,0,2.451-8.458,5.77,5.77,0,0,0-.6-.9l5.464-2.994A1.314,1.314,0,0,0,150.12,129.524Zm-19.554-25.616a1.306,1.306,0,0,1,1.553,1.01l3.05,14.2a1.306,1.306,0,0,1-1.01,1.553,1.444,1.444,0,0,1-.281.037,1.3,1.3,0,0,1-1.272-1.029l-3.05-14.2A1.316,1.316,0,0,1,130.567,103.908Z",
    transform: "translate(-47.039)",
    fill: "#5763f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2515",
    "data-name": "Path 2515",
    d: "M28.273,260.81a1.3,1.3,0,0,0-1.31-1.31H13.21a1.31,1.31,0,0,0,0,2.62H26.963A1.3,1.3,0,0,0,28.273,260.81Z",
    transform: "translate(0 -132.895)",
    fill: "#5763f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2516",
    "data-name": "Path 2516",
    d: "M91.6,358.01a1.3,1.3,0,0,0,1.31,1.31h16.971a1.31,1.31,0,0,0,0-2.62H92.91A1.3,1.3,0,0,0,91.6,358.01Z",
    transform: "translate(-64.787 -211.907)",
    fill: "#5763f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2517",
    "data-name": "Path 2517",
    d: "M39.6,317.81a1.3,1.3,0,0,0,1.31,1.31H63.869a1.31,1.31,0,1,0,0-2.62H40.91A1.3,1.3,0,0,0,39.6,317.81Z",
    transform: "translate(-22.517 -179.229)",
    fill: "#5763f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2518",
    "data-name": "Path 2518",
    d: "M123.366,288.02a1.31,1.31,0,0,0,0-2.62H117.21a1.31,1.31,0,0,0,0,2.62Z",
    transform: "translate(-84.54 -153.949)",
    fill: "#5763f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2519",
    "data-name": "Path 2519",
    d: "M193.773,328H190.91a1.31,1.31,0,1,0,0,2.62h2.863a1.31,1.31,0,1,0,0-2.62Z",
    transform: "translate(-144.45 -188.577)",
    fill: "#5763f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2520",
    "data-name": "Path 2520",
    d: "M159.062,388H148.21a1.31,1.31,0,1,0,0,2.62h10.853a1.31,1.31,0,0,0,0-2.62Z",
    transform: "translate(-109.739 -237.351)",
    fill: "#5763f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2521",
    "data-name": "Path 2521",
    d: "M75.087,388H66.91a1.31,1.31,0,0,0,0,2.62h8.177a1.31,1.31,0,0,0,0-2.62Z",
    transform: "translate(-43.652 -237.351)",
    fill: "#5763f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2522",
    "data-name": "Path 2522",
    d: "M26.813,353.5h-4.3a1.31,1.31,0,1,0,0,2.62h4.3a1.31,1.31,0,1,0,0-2.62Z",
    transform: "translate(-7.56 -209.306)",
    fill: "#5763f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2523",
    "data-name": "Path 2523",
    d: "M57.4,288.02a1.31,1.31,0,0,0,0-2.62H55.21a1.31,1.31,0,0,0,0,2.62Z",
    transform: "translate(-34.141 -153.949)",
    fill: "#5763f3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight2);
export default __webpack_public_path__ + "static/media/right_2.16e7b21f9ab8caf6565ab1127956e5ad.svg";
export { ForwardRef as ReactComponent };